import { useTemplate } from '../../../hooks/index'
import { getRequestParamter, post, get, getValueByPath } from '../../../utils/index'
import { pgMessage } from '../../message/index'
import { lodop } from '../utils/lodop'
import { jmreport } from '../utils/jmreport'
import { browser } from '../utils/browser'
import { fineReport } from '../utils/fine-report'
import { labelPrinter } from '../utils/label-printer'
import { browserex } from '../utils//browserex'
import { label } from '../utils/label'

const printMethods = {
  lodop,
  jmreport,
  browser,
  fineReport,
  labelPrinter,
  browserex,
  label,
}

export function usePrint({
  orderData,
  extendData,
  savePrintCount,
  savePrintCountParams,
  orderDataId,
  printBefore,
}) {
  const { getTemplateData, compileData } = useTemplate()

  const getTemplateCompileData = (printTemplate, orderDataValue) => {
    const batchPrint = Array.isArray(orderDataValue)
    const datas =
      !orderDataValue || Array.isArray(orderDataValue) ? orderDataValue : [orderDataValue]
    const compile = getTemplateData(null, extendData)
    const compileDatas = datas.map((data) => {
      const temCompile = { ...compile, data }
      const url = compileData(printTemplate.url, temCompile)
      const urlParam = getRequestParamter(url)
      return {
        compileSource: { ...compile, orderData: data, ...urlParam }, //编译数据，{data, ...extendData, route}
        url,
        urlParam, // 默版url解析参数
      }
    })

    return {
      extendData,
      compileDatas, //编译数据
      batchPrint, // 是否批量打印
      printTemplate, //模板信息
    }
  }

  // ['zebra', 'postek', 'lodop', 'sato', 'browser']
  const print = async (template) => {
    const printServer = [
      'zebra',
      'postek',
      'sato',
      'lodop',
      'browserex',
      'browser',
      'jmreport',
      'label',
    ].includes(template.server?.code)
      ? template.server?.code
      : 'fineReport'
    const printMethod = ['zebra', 'postek', 'sato'].includes(printServer)
      ? 'labelPrinter'
      : printServer

    const [res] = await get('rest/ezcomp/report/templateDetail', { id: template.id })
    if (!res) {
      return Promise.reject('获取打印模板失败')
    }
    const printTemplate = res.data
    const orderDataValue =
      (await printBefore?.({
        printTemplate,
        orderData,
        extendData,
        printRun: (printOrderData) =>
          printMethods[printMethod](getTemplateCompileData(printTemplate, printOrderData)),
        savePrintCountMethod,
      })?.catch((error) => ({
        error,
      }))) ?? orderData
    if (orderDataValue?.error) {
      return Promise.reject(orderDataValue?.error)
    }

    return printMethods[printMethod](getTemplateCompileData(printTemplate, orderDataValue)).then(
      () => {
        pgMessage.success('打印命令已发送')
        return savePrintCountMethod(orderDataValue)
      }
    )
  }

  const savePrintCountMethod = (orderDatas) => {
    if (savePrintCount) {
      const datas = Array.isArray(orderDatas) ? orderDatas : [orderDatas]
      return Promise.all(
        datas.map((data) =>
          post(savePrintCount, {
            id: getValueByPath(data, orderDataId),
            ...savePrintCountParams,
          })
        )
      )
    }
  }

  return {
    print,
  }
}
